<script setup lang="ts">
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import { capitalize } from "lodash-es";
import { computed } from "vue";

import type { DictsysInflectionSchemeTable } from "@/types";

import LeInflectionSchemeTable from "./LeInflectionSchemeTable.vue";

// Some schemes have some simple toggle-able extra tables. This component is used to render those tables.

const props = defineProps<{
  table: DictsysInflectionSchemeTable;
  language: string;
  heading?: string;
}>();

const heading = computed<string>(() => {
  if (props.heading) {
    return props.heading;
  }

  return capitalize(props.table.header);
});
</script>

<template>
  <div class="le-extra-inflection-scheme">
    <LeHeading tag="h3" size="s">{{ heading }}</LeHeading>
    <LeInflectionSchemeTable
      class="le-extra-inflection-scheme__table"
      :tables="[props.table]"
      :language="props.language"
    />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-extra-inflection-scheme__table {
  width: 45%;
  margin-top: 6px;

  // Unset some inner styles - otherwise the first row of the table is treated like a sub-heading row
  :deep(.le-inflection-scheme-table__text--grid) {
    display: inline;
    width: unset;
    height: unset;
  }
}
</style>
